import { darken as polishedDarken } from 'polished';

export default function darken(color, amount) {
  try {
    return polishedDarken(amount, color);
  } catch (e) {
    return color;
  }
}
